export default __webpack_public_path__ + "static/media/012-Great Dane.6649c322.svg";